// Parse the complete description before splitting, so neither fragment can
// open or close a surrounding theme container.
const marker = '[[split]]';

function splitDescription(source, part) {
  const template = document.createElement('template');
  template.innerHTML = source;
  const walker = document.createTreeWalker(template.content, NodeFilter.SHOW_TEXT);
  let text;
  let boundary = null;
  let offset = -1;
  while ((text = walker.nextNode())) {
    const index = text.data.indexOf(marker);
    if (index !== -1) {
      boundary = text;
      offset = index;
      break;
    }
  }

  let fragment;
  if (boundary) {
    const range = document.createRange();
    range.selectNodeContents(template.content);
    if (part === 'intro') range.setEnd(boundary, offset);
    else range.setStart(boundary, offset + marker.length);
    fragment = range.cloneContents();
  } else {
    fragment = part === 'intro'
      ? template.content.cloneNode(true)
      : document.createDocumentFragment();
  }

  // Additional separators must not discard the text between them.
  const remaining = document.createTreeWalker(fragment, NodeFilter.SHOW_TEXT);
  while ((text = remaining.nextNode())) text.data = text.data.split(marker).join('');
  return fragment;
}

if (!customElements.get('r2d-product-description')) {
  customElements.define('r2d-product-description', class extends HTMLElement {
    connectedCallback() {
      const render = () => {
        if (!this.isConnected || this.hasAttribute('data-split-ready')) return;
        const source = this.getAttribute('data-source');
        if (source === null) return;
        try {
          const fragment = splitDescription(source, this.getAttribute('data-part'));
          this.replaceChildren(fragment);
          this.setAttribute('data-split-ready', '');
          this.removeAttribute('data-source');
        } catch (error) {
          // Keep the readable server-rendered fallback if enhancement fails.
          console.warn('Product description could not be split safely.', error);
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', render, { once: true });
      } else render();
    }
  });

  document.addEventListener('click', event => {
    const button = event.target.closest('.r2d-read-more[data-r2d-product-id]');
    if (!button) return;
    const scope = button.closest('.modal, quick-add-modal') || document;
    const productId = button.getAttribute('data-r2d-product-id');
    const detail = Array.from(scope.querySelectorAll('r2d-product-description[data-part="rest"]'))
      .find(element => element.getAttribute('data-product-id') === productId);
    const panel = detail && detail.closest('.collapsible-content');
    if (!panel) return;
    const trigger = Array.from(scope.querySelectorAll('.collapsible-trigger[aria-controls]'))
      .find(element => element.getAttribute('aria-controls') === panel.id);
    if (!trigger) return;
    event.preventDefault();
    if (!trigger.classList.contains('is-open') && trigger.getAttribute('aria-expanded') !== 'true') {
      trigger.click();
    }
    window.setTimeout(() => {
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      trigger.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }, 350);
  });
}
